import { api } from '@/api';

export interface DeviceModel {
  id: number;
  name: string;
}

export interface DeviceModelDetailIdName {
  id: number;
  name: string;
}

export interface DeviceModelDetailCountry {
  countryID: string;
}

export interface DeviceModelDetail {
  id: number;
  name: string;
  firmwareTypes: DeviceModelDetailIdName[];
  countries: DeviceModelDetailCountry[];
  userLevels: DeviceModelDetailIdName[];
}

export async function fetchDeviceModels(): Promise<DeviceModel[]> {
  return api.get<DeviceModel[]>('/v1/deviceModels');
}

export async function fetchDeviceModelById(id: number): Promise<DeviceModelDetail> {
  return api.get<DeviceModelDetail>(`/v1/deviceModels/${id}`);
}
